import _extends from "@babel/runtime/helpers/extends";
import { Fragment } from "react";
import { useBlocker } from "../../contexts";
import { BlockerFooterInlineStyles, BlockerFooterLink } from ".";
import { getOtherOptionsFromWindow, jsxJoin } from "../../utils";
import { BannerTooltip } from "../banner";
import { usePageIdToPermalinkMapLink } from "../../hooks";

var BlockerFooter = function BlockerFooter() {
  var blocker = useBlocker();
  var _blocker$legal = blocker.legal,
      privacyPolicy = _blocker$legal.privacyPolicy,
      privacyPolicyLabel = _blocker$legal.privacyPolicyLabel,
      imprint = _blocker$legal.imprint,
      imprintLabel = _blocker$legal.imprintLabel,
      _blocker$footerDesign = blocker.footerDesign,
      poweredByLink = _blocker$footerDesign.poweredByLink,
      linkTarget = _blocker$footerDesign.linkTarget,
      poweredLink = blocker.poweredLink;
  var targetAttributes = linkTarget === "_blank" ? {
    target: "_blank",
    rel: "noopener"
  } : {};

  var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
      isPro = _getOtherOptionsFromW.isPro,
      affiliate = _getOtherOptionsFromW.affiliate;

  var linkImprint = usePageIdToPermalinkMapLink(imprint);
  var linkPrivacyPolicy = usePageIdToPermalinkMapLink(privacyPolicy);
  var links = jsxJoin([!!privacyPolicyLabel && h(BlockerFooterLink, _extends({
    href: linkPrivacyPolicy
  }, targetAttributes, {
    key: "privacyPolicy"
  }), privacyPolicyLabel), !!imprintLabel && h(BlockerFooterLink, _extends({
    href: linkImprint
  }, targetAttributes, {
    key: "imprint"
  }), imprintLabel)], h(Fragment, null, " \u2022 "));
  return h("div", BlockerFooterInlineStyles.footerContainer(blocker), h("div", BlockerFooterInlineStyles.footer(blocker), links, !!poweredLink && (poweredByLink || !isPro) && h(Fragment, null, links !== null && h("br", null), h(BlockerFooterLink, {
    href: affiliate ? affiliate.link : poweredLink.href,
    target: poweredLink.target
  }, h("span", {
    dangerouslySetInnerHTML: {
      __html: poweredLink.innerHTML
    }
  }), affiliate && h(BannerTooltip, {
    title: affiliate.description
  }, " ", affiliate.labelBehind)), " ")));
};

export { BlockerFooter };